import { createContext } from 'react'

export type SsrContextType = {
  isMobileUA?: boolean
  processEnv?: string
}

export const SsrContext = createContext<SsrContextType>({})
